import { Avatar, Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CustomGridToolbar from "../../../../components/datagrid/GridToolBar";
import { useEffect, useState } from "react";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import { useDispatch, useSelector } from "react-redux";
import { getAllQrcodes } from "../../../../redux/features/qrCodesSlice";
import CreateQrCode from "./CreateQrCode";
import DeleteQrCode from "./DeleteQrCode";
import DownloadQrCode from "./DowloadQrCode";

const columns = [
  {
    field: "serialNumber",
    headerName: "slNo",
    width: 80,
  },
  //   {
  //     field: "qr_id",
  //     headerName: "ID",
  //     width: 80,
  //   },
  {
    field: "name",
    headerName: "QR Name",
    flex: 1,
    minWidth: 300,
  },
  {
    field: "link",
    headerName: "Link",
    flex: 1,
    minWidth: 300,
    renderCell: (params) => (
      <a
        href={params.value}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#1976d2", textDecoration: "underline" }}
      >
        {params.value}
      </a>
    ),
  },
  {
    field: "description",
    headerName: "Description",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "qr_image",
    headerName: "QR Image",
    width: 120,
    renderCell: (params) => (
      <Avatar
        variant="square"
        src={params.value}
        alt="QR Code"
        sx={{ width: 60, height: 60 }}
      />
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: "isActive",
    headerName: "Active",
    width: 100,
    renderCell: (params) => (
      <Box
        sx={{
          color: params.value ? "green" : "red",
          fontWeight: "bold",
        }}
      >
        {params.value ? "Yes" : "No"}
      </Box>
    ),
  },
  //   {
  //     field: "created_by",
  //     headerName: "Created By",
  //     width: 120,
  //   },
  {
    field: "Download",
    headerName: "Download",
    width: 120,
    renderCell: (params) => {
      return <DownloadQrCode id={params.id} name={params.row.name} />;
    },
  },
  {
    field: "Delete",
    headerName: "Delete",
    width: 120,
    renderCell: (params) => {
      return <DeleteQrCode id={params.id} />;
    },
  },
];

const QrCode = () => {
  const dispatch = useDispatch();
  const [gridSize, setGridSize] = useState(10);
  const { loading, qrCodeData } = useSelector((state) => state.qrCodes);

  useEffect(() => {
    dispatch(getAllQrcodes());
  }, []);

  return (
    <Box>
      <GlobalWrapper title={"QR Codes"} actions={<CreateQrCode />}>
        <DataGrid
          components={{ Toolbar: CustomGridToolbar }}
          rows={qrCodeData}
          columns={columns}
          loading={loading}
          getRowId={(row) => row.qr_id}
          pageSize={gridSize}
          autoHeight
          rowsPerPageOptions={[5, 10, 25, 50]}
          onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
        />
      </GlobalWrapper>
    </Box>
  );
};

export default QrCode;
